import GestureRecognizer from './_gestureRecognizer.js';

export default class Lightbox {
	constructor(imageSources) {
		this.sources = imageSources;
		this.current = 0;

		this.lightbox = document.getElementById('lightbox');

		this.lightbox.querySelector('[data-dir="prev"]').addEventListener('click', () => this.previous());
		this.lightbox.querySelector('[data-dir="next"]').addEventListener('click', () => this.next());

		this.lightbox.querySelector('[data-close]').addEventListener('click', () => this.hide());

		this.gestureRecognizer = new GestureRecognizer(this.lightbox);
		this.gestureRecognizer.on('swipeleft', () => this.next());
		this.gestureRecognizer.on('swiperight', () => this.previous());
	}

	show() {
		this.lightbox.classList.remove('hidden');
		document.body.style.overflow = 'hidden';
	}

	hide() {
		this.lightbox.classList.add('hidden');
		document.body.style.overflow = 'auto';
	}

	previous() {
		if(this.current === 0)
			this.go(this.sources.length - 1);
		else
			this.go(this.current - 1);
	}

	next() {
		if(this.current === this.sources.length - 1)
			this.go(0);
		else
			this.go(this.current + 1);
	}

	go(index) {
		if(index < 0)
			index = 0;
		else if(index >= this.sources.length)
			index = this.sources.length - 1;

		this.current = index;
		this.lightbox.style.backgroundImage = `url(${this.sources[index]})`;
	}
}
